import { render, staticRenderFns } from "./listApplyRoomDiscountRecordList.vue?vue&type=template&id=fe0ff230&scoped=true"
import script from "./listApplyRoomDiscountRecordList.vue?vue&type=script&lang=js"
export * from "./listApplyRoomDiscountRecordList.vue?vue&type=script&lang=js"
import style0 from "./listApplyRoomDiscountRecordList.vue?vue&type=style&index=0&id=fe0ff230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0ff230",
  null
  
)

export default component.exports